import React from 'react'
import classNames from 'classnames'
import styles from '../Workflows.module.scss'

interface LibrarySectionProps {
  title: string
  subtitle: string
  emptyMessage: string
  isEmpty: boolean
  children: React.ReactNode
}

export const LibrarySection: React.FC<LibrarySectionProps> = ({ title, subtitle, emptyMessage, isEmpty, children }) => (
  <section className='d-flex flex-column gap-2'>
    <div>
      <h5 className='mb-0'>{title}</h5>
      <div className='paragraph-small zocks-text-gray-600'>{subtitle}</div>
    </div>
    {isEmpty ? (
      <div className='paragraph-small zocks-text-gray-500'>{emptyMessage}</div>
    ) : (
      <div className={classNames('d-grid gap-3 align-items-start w-100', styles.tileGrid)}>{children}</div>
    )}
  </section>
)
